module.exports = __webpack_public_path__ + "media/דובי.ef1543e9.mp3";